import { ModalHandler } from '@app-velocity/ui';

import { AboutModalContent } from './components/AboutModalContent';

export const AboutModal = () => {
  return (
    <ModalHandler channel="system" id="about">
      <AboutModalContent />
    </ModalHandler>
  );
};
